module.exports = __webpack_public_path__ + "static/media/third_image.0e83da6b.png";